
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/weeebates/share/grocery/landing/[id]",
      function () {
        return require("private-next-pages/weeebates/share/grocery/landing/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/weeebates/share/grocery/landing/[id]"])
      });
    }
  